import { Trans } from '@lingui/macro';
import React from 'react';

import { useSelectorSchool } from '../../../../../user-profiles';
import { useSelectorUserProfileType } from '../../../user-profile';
import {
    SchoolInfoWrapper, SchoolInfoText
} from './school-info.styled';
import { UserTypes } from '@api';

export const SchoolInfo = () => {
    const school = useSelectorSchool();
    const userProfileType = useSelectorUserProfileType();
    const getSchoolInfoText = () => {
        const schoolName = school?.name;

        switch (userProfileType) {
        case UserTypes.teachers: return <SchoolInfoText>{schoolName}&nbsp;<Trans id={'header.teachConsole'} /></SchoolInfoText>;
        case UserTypes.internalUsers: return <SchoolInfoText>{schoolName}&nbsp;<Trans id={'header.internalConsole'} /></SchoolInfoText>;
        case UserTypes.schoolAdmins: return <SchoolInfoText>{schoolName}&nbsp;<Trans id={'header.adminConsole'} /></SchoolInfoText>;
        default: return <SchoolInfoText>{schoolName}</SchoolInfoText>;
        }
    };

    return (
        <SchoolInfoWrapper data-testid={'school-name'} noOfLines={2}>
            {getSchoolInfoText()}
        </SchoolInfoWrapper>
    );
};
